/**
 * Signed-in directory Sort preferences — platform identity API.
 * GET/PUT `/api/v1/customer-account/preferences/directory-ui`
 */

import { fetchPlatformAccountJson } from './platformAccountFetch.js';

export const PLATFORM_DIRECTORY_UI_PREFS_PATH =
  '/api/v1/customer-account/preferences/directory-ui';

export type DirectoryUiShopsSortId =
  | 'nameAsc'
  | 'nameDesc'
  | 'orgAsc'
  | 'distanceAsc'
  | 'favoriteDesc';

export type DirectoryUiOrgsSortId = 'nameAsc' | 'nameDesc';

export interface DirectoryUiPreferenceDTO {
  readonly shops: Readonly<Record<string, DirectoryUiShopsSortId>>;
  readonly orgs: DirectoryUiOrgsSortId;
  readonly favorites: DirectoryUiShopsSortId;
  /** GET only — false when no DB row yet (FE seeds from localStorage). */
  readonly stored?: boolean;
}

export type DirectoryUiPreferencePutBody = {
  readonly shops?: Readonly<Record<string, DirectoryUiShopsSortId>>;
  readonly orgs?: DirectoryUiOrgsSortId;
  readonly favorites?: DirectoryUiShopsSortId;
};

export async function fetchDirectoryUiPreferences(
  apiBaseUrl: string,
  signal?: AbortSignal,
): Promise<DirectoryUiPreferenceDTO> {
  return fetchPlatformAccountJson<DirectoryUiPreferenceDTO>({
    apiBaseUrl,
    path: PLATFORM_DIRECTORY_UI_PREFS_PATH,
    method: 'GET',
    signal,
  });
}

export async function putDirectoryUiPreferences(
  apiBaseUrl: string,
  body: DirectoryUiPreferencePutBody,
  signal?: AbortSignal,
): Promise<DirectoryUiPreferenceDTO> {
  return fetchPlatformAccountJson<DirectoryUiPreferenceDTO>({
    apiBaseUrl,
    path: PLATFORM_DIRECTORY_UI_PREFS_PATH,
    method: 'PUT',
    body,
    signal,
  });
}
